import { IApiPromise } from "@/interfaces/responseData";
import { Checklist } from "../apiRoutes/routes";
import api from "@/interceptors";
import { showErrorAPI } from "../apiRoutes";
import store from "@/store";

export const getQuickWinAndRoadMapData = (checklist: any) => {
  if (!checklist || !checklist.length) return { quickWins: [], roadMap: [] };
  const quickWins = checklist.filter((group) => group.checklistGroupIsQuickWin);
  const roadMap = checklist.filter((group) => !group.checklistGroupIsQuickWin);

  quickWins.forEach((group, index) => {
    group.index = index + 1;
  });
  roadMap.forEach((group, index) => {
    group.index = quickWins.length + index + 1;
  });
  return { quickWins, roadMap };
};

export const getDataChart = (data: any) => {
  const checklistDate = data?.checklistSummary?.checklistDate;
  let checklistForecasts = data.checklistForecasts
    ? data.checklistForecasts
        .map((item) => ({
          date: item.checklistForecastDate,
          score: item.checklistForecastScore,
        }))
        .filter(
          (item) =>
            new Date(item.date).getTime() > new Date(checklistDate).getTime(),
        )
    : [];
  checklistForecasts = checklistForecasts.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
  let checklistHistory = data.checklistHistory
    ? data.checklistHistory.map((item) => ({
        date: item.checklistHistoryDate,
        score: item.checklistHistoryScore,
      }))
    : [];
  checklistHistory = checklistHistory.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
  return { checklistHistory, checklistForecasts };
};

export const handleChecklistDataReportSplit = async (
  route: string,
  checklistId: number | string,
  isActiveCall = true,
) => {
  try {
    if (!isActiveCall) {
      return false;
    }
    store.commit("Sharing/SET_LOADING_SPLIT_CHECKLIST_REPORT", {
      key: route,
      value: true,
    });
    const res = await api.get(
      route.replace(":checklistId", checklistId.toString()),
    );
    const data = res.data.data;
    store.commit("Sharing/ADD_CHECKLIST_REPORT", {
      ...data,
      ...(route === Checklist.getChecklistReportDataHistory
        ? { checklistHistory: data.checklistHistories ?? [] }
        : {}),
    });
    if (data.checklistGroups) {
      const newData = getQuickWinAndRoadMapData(data.checklistGroups);
      store.commit("Sharing/SET_CHECKLIST_QUICK_WIN", newData.quickWins);
      store.commit("Sharing/SET_CHECKLIST_ROAD_MAP", newData.roadMap);
    }
  } catch (error) {
    showErrorAPI(error, route);
    return false;
  } finally {
    store.commit("Sharing/SET_LOADING_SPLIT_CHECKLIST_REPORT", {
      key: route,
      value: false,
    });
  }
};

export const putChecklistCategoryInfo = (
  checklistId: any,
  categoryId: any,
  checklistCategoryNotes: any,
): IApiPromise<any> =>
  api.post(
    Checklist.putChecklistCategoryInfo
      .replace(":checklistId", checklistId)
      .replace(":categoryId", categoryId),
    {
      checklistCategoryNotes: checklistCategoryNotes,
    },
  );
